import { Checkout, RichContentIntro } from '@insify/funnel-components';
import { formatMoney } from '@insify/global-money';
import { useTranslation } from 'react-i18next';

import { useContent } from '../../../../hooks/useContent';
import { useParamsQuery } from '../../../../hooks/useQueries';

import styles from './Company.module.css';

const useMapboxAccessToken = (): string => {
  if (typeof window.insify_runtime_config.MAPBOX_ACCESS_TOKEN !== 'string') {
    throw new Error('MAPBOX_ACCESS_TOKEN is not defined');
  }

  const mapboxAccessToken = window.insify_runtime_config.MAPBOX_ACCESS_TOKEN;

  return mapboxAccessToken;
};

export const Company = (): JSX.Element | null => {
  const mapboxAccessToken = useMapboxAccessToken();

  const { t } = useTranslation(['funnel']);
  const { checkoutCompany } = useContent() || {};
  const { data, isFetched } = useParamsQuery();

  if (!isFetched || !data) return null;

  const { address, companyName, headCount, annualRevenue, activities } = data;

  if (!companyName || !annualRevenue || !activities) return null;

  return (
    <>
      <RichContentIntro content={checkoutCompany} />
      <Checkout.CompanyDetails
        className={styles.companyDetails}
        mapboxAccessToken={mapboxAccessToken}
        geolocation={address?.geoLocation}
        companyName={companyName}
        headcountAndRevenueText={t('funnel:checkout_company_headcount_and_revenue', {
          headcount: headCount,
          revenue: formatMoney(annualRevenue, 'fr-FR'),
        })}
        addressText={`${address?.houseNumber} ${address?.street}, ${address?.postalCode} ${address?.city}`}
        activitiesListTitle={t('funnel:checkout_company_activities')}
        activities={activities.map((activity) => activity.title)}
      />
    </>
  );
};
